{
  "deprecatedBrowser": "您的浏览器不受支持",
  "deprecatedBrowserHelpText": "请考虑将您的浏览器更新至最新版本，以确保享有最佳体验。"
}
